import { Record } from 'immutable';

export default class ExportSpec extends Record(
  { query: '',
    delimiter: ',',
    enteredName: undefined }) {

  get ready() { return true; }

  get valid() { return this.jobName !== '' && this.query.length > 0 && this.delimiter !== undefined; }

  get jobName() {
    if (this.enteredName !== undefined) {
      return this.enteredName;
    } else {
      let queryDesc = '';
      if (this.query.length < 33) {
        queryDesc = this.query;
      } else {
        queryDesc = `${this.query.substring(0, 15)}...${this.query.substring(this.query.length - 15, this.query.length)}`;
      }

      return `Exporting query '${queryDesc}'`;
    }
  }

  get configJson() {
    return {
      jobType: 'giraffe',
      config: [
        {
          jobType: 'sql_runner',
          config: {
            queryType: 'Unload',
            dbInfo: {
              driver: 'Redshift',
              server: 'bl-int-analytics1.cxtyzogmmhiv.us-east-1.redshift.amazonaws.com',
              port: 5439,
              database: 'analytics',
              username: 'fake',
            },
            fromFile: false,
            unloadInfo: {
              query: this.query,
              delimiter: this.delimiter,
            },
          },
        },
        {
          jobType: 'file_cat',
        },
      ],
    };
  }
}
